import {Component, OnInit} from '@angular/core';
import {USER_PRIVILEGES} from '../../../../constants/privileges';
import {User} from '../../../data/models/user';
import {MatDialog} from '@angular/material/dialog';
import {ActivatedRoute, Router} from '@angular/router';
import {MeService} from '../../../services/api/me.service';
import {UserService} from '../../../services/api/user.service';
import {UserDeleteDialogComponent} from '../../../components/dialogs/user-delete-dialog/user-delete-dialog.component';
import {UserBlockDialogComponent} from '../../../components/dialogs/user-block-dialog/user-block-dialog.component';
import {UserUnblockDialogComponent} from '../../../components/dialogs/user-unblock-dialog/user-unblock-dialog.component';
import {UserEditDialogComponent} from '../../../components/dialogs/user-edit-dialog/user-edit-dialog.component';
import {UserResetPasswordDialogComponent} from '../../../components/dialogs/user-reset-password-dialog/user-reset-password-dialog.component';

@Component({
  selector: 'app-user-page',
  templateUrl: './user-page.component.html',
  styleUrls: ['./user-page.component.css']
})
export class UserPageComponent implements OnInit {

  readonly PRIVILEGES = USER_PRIVILEGES;

  user: User | null = null;

  canEdit = false;
  canDelete = false;
  canBlock = false;
  canUnblock = false;
  canResetPassword = false;

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private meService: MeService,
    private userService: UserService,
  ) {
  }

  ngOnInit(): void {
    const id = +(this.route.snapshot.paramMap.get('userId') || 0);
    if (id) {
      this.userService.getUser(id)
        .then(user => {
          this.user = user;
          this.updatePermissions();
        });
    }
  }

  updatePermissions(): void {
    if (this.user && this.meService.me) {
      this.canEdit = this.meService.hasPrivilege(this.PRIVILEGES.UPDATE);
      this.canDelete = this.user.id !== this.meService.me.id && this.user.deleteDate == null &&
        this.meService.hasPrivilege(this.PRIVILEGES.DELETE);
      this.canBlock = this.user.id !== this.meService.me.id && this.user.blockDate == null && this.user.deleteDate == null &&
        this.meService.hasPrivilege(this.PRIVILEGES.BLOCK);
      this.canUnblock = this.user.id !== this.meService.me.id && this.user.blockDate != null && this.user.deleteDate == null &&
        this.meService.hasPrivilege(this.PRIVILEGES.UNBLOCK);
      this.canResetPassword = this.user.id !== this.meService.me.id &&
        this.meService.hasPrivilege(this.PRIVILEGES.UPDATE);
    }
  }

  formatRoles(): string {
    if (this.user) {
      return this.user?.roles.map(r => r.name).join(', ');
    }
    return '';
  }

  openUserEditDialog(): void {
    const dialogRef = this.dialog.open(UserEditDialogComponent, {
      maxWidth: '400px',
      data: {
        user: this.user
      }
    });

    dialogRef.afterClosed().subscribe(user => {
      if (user) {
        this.user = user;
        this.updatePermissions();
      }
    });
  }

  openUserResetPasswordDialog(): void {
    const dialogRef = this.dialog.open(UserResetPasswordDialogComponent, {
      width: '90vw',
      maxWidth: '400px',
      data: {
        user: this.user
      }
    });

    dialogRef.afterClosed().subscribe(user => {
      if (user) {
        this.user = user;
        this.updatePermissions();
      }
    });
  }

  openUserBlockDialog(): void {
    const dialogRef = this.dialog.open(UserBlockDialogComponent, {
      minWidth: '10vw',
      data: {
        user: this.user
      }
    });

    dialogRef.afterClosed().subscribe(user => {
      if (user) {
        this.user = user;
        this.updatePermissions();
      }
    });
  }

  openUserUnblockDialog(): void {
    const dialogRef = this.dialog.open(UserUnblockDialogComponent, {
      minWidth: '10vw',
      data: {
        user: this.user
      }
    });

    dialogRef.afterClosed().subscribe(user => {
      if (user) {
        this.user = user;
        this.updatePermissions();
      }
    });
  }

  openUserDeleteDialog(): void {
    const dialogRef = this.dialog.open(UserDeleteDialogComponent, {
      data: {
        user: this.user,
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.router.navigate(['users']);
      }
    });
  }

}
